// import InsertCashTemplate from '@/components/templates/insertCash/insertCashTemplate'
import PaymentInProgress from '@/components/templates/paymentInProgress/paymentInProgress'

export default function InsertCashPage() {
    return <PaymentInProgress />
    // <InsertCashTemplate navigate={navigate} selectedVoucherType={voucherType} />
}
